import {Injectable} from '@angular/core'
import {Backend} from "@generated-backend-types";
import {BaseEndpointService} from '../base-endpoint-service';
import TableFilterFavoriteData = Backend.App.Data.Settings.TableFilterFavoriteData;
import TableFilterFavorite = Backend.App.Resources.Dashboard.Settings.TableFilterFavorite;
import {ListItem} from '../../../entities/list-item.entity';


@Injectable({providedIn: 'root'})
export class TableFilterFavoritesService extends BaseEndpointService<TableFilterFavorite, TableFilterFavoriteData> {
  protected override endpoint = '/settings/table-filter-favorites'

  public override modelToMultiSelectItem(m: TableFilterFavorite): ListItem & { model: TableFilterFavorite; } {
    return {
      id: m.id,
      text: m.title,
      isDisabled: false,
      model: m,
    }
  }
}
